<template>
<div>
    HOMOLOGACIONES 2
</div>
</template>

<script>
export default {

    data() {
        return {

        }
    },

    mounted() {}
}
</script>
